<div
  class="component-actions-container ion-padding-start ion-padding-end ion-padding-top"
>
  <ion-button
    (click)="openRunQueryModal()"
    fill="clear"
    color="dark"
    class="button-dark-border"
    [disabled]="!featureEnabled"
    title="Test AI-generated response"
  >
    <ion-icon name="flask" slot="icon-only" class="shown-sm"></ion-icon>
    <ion-icon name="flask" class="hidden-sm"></ion-icon>
    <span class="text-with-left-icon hidden-sm"> Test Response</span>
  </ion-button>

  <div class="right-buttons-group">
    <ion-button
      (click)="createArticle()"
      [disabled]="!featureEnabled"
      color="dark"
    >
      <ion-icon name="document-text-outline"></ion-icon>
      <span class="icon-plus-accessory">+</span>
      <span class="text-with-left-icon hidden-sm"> New Article </span>
    </ion-button>
    <ion-button
      (click)="showImportDocumentOptions($event)"
      [disabled]="!featureEnabled"
      color="dark"
    >
      <ion-icon name="cloud-upload-outline"></ion-icon>
      <span class="text-with-left-icon hidden-sm"> Import Document </span>
    </ion-button>
    <ion-button
      (click)="createRootCollection()"
      [disabled]="!featureEnabled"
      color="dark"
    >
      <ion-icon name="folder-open"></ion-icon>
      <span class="icon-plus-accessory">+</span>
      <span class="text-with-left-icon hidden-sm"> New Collection </span>
    </ion-button>
  </div>
</div>

<ion-card>
  <ion-toolbar>
    <ion-searchbar
      class="header-search"
      mode="ios"
      placeholder="Search articles..."
      [(ngModel)]="searchTerm"
      (ionInput)="onSearchChange()"
      debounce="300"
      showClearButton="never"
    ></ion-searchbar>
    <ion-buttons slot="end">
      <app-filter-button
        [options]="filterOptions"
        (didChange)="filtersDidChange($event)"
        [projectId]="authService.selectedProject?.id ?? undefined"
      ></app-filter-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="tree-container">
    <!-- Loading State -->
    <ion-list lines="none" *ngIf="isLoading">
      <ion-item *ngFor="let i of [1, 2, 3]">
        <!-- Skeleton items -->
        <ion-skeleton-text
          animated
          style="width: 60%; height: 16px"
        ></ion-skeleton-text>
      </ion-item>
    </ion-list>

    <!-- Truly Empty State (No Collections loaded at all) -->
    <div
      *ngIf="!isLoading && !treeNodes.length && !allCollections.length"
      class="empty-tree-message"
    >
      No collections exist yet.
      <!-- Add button to create first collection? -->
    </div>

    <!-- Filtered Empty State (Collections exist, but no matching articles for current filter/search) -->
    <div
      *ngIf="
        !isLoading &&
        allCollections.length > 0 &&
        treeNodes.length === 0 &&
        (filters.size > 0 || (searchTerm && searchTerm.length > 0))
      "
      class="empty-tree-message"
    >
      No articles match the current search or filters.
    </div>

    <!-- Header Row -->
    <div class="tree-header" *ngIf="!isLoading && treeNodes.length">
      <!-- Select All Checkbox Removed -->
      <span class="header-column header-name">
        Name
        <!-- <ion-icon
          *ngIf="sortField === 'name'"
          [name]="sortDescending ? 'chevron-up-outline' : 'chevron-down-outline'"
        ></ion-icon> -->
      </span>
      <span class="header-column header-updated-at">
        Updated At
        <!-- <ion-icon
          *ngIf="sortField === 'updatedAt'"
          [name]="sortDescending ? 'chevron-up-outline' : 'chevron-down-outline'"
        ></ion-icon> -->
      </span>
    </div>

    <!-- Tree Nodes (using recursive template) -->
    <!-- Render tree if !isLoading AND treeNodes array has content -->
    <ion-list lines="none" *ngIf="!isLoading && treeNodes.length">
      <!-- Add root drop zone for moving items to top level -->
      <div
        class="root-drop-zone"
        aria-label="Knowledge Base Root (Drop here to move item to top level)"
      >
        <!-- Recursively render top-level nodes -->
        <ng-container
          *ngTemplateOutlet="treeNodeTemplate; context: { nodes: treeNodes }"
        ></ng-container>
      </div>
    </ion-list>
  </div>
</ion-card>

<ion-footer
  [class.bulk-actions-active]="selectedArticleIds.size > 0"
  class="tree-list-footer"
>
  <div class="footer-content">
    <span *ngIf="selectedArticleIds.size === 0" class="footer-text">
      Displaying {{ currentArticles.length }} articles
    </span>
    <span *ngIf="selectedArticleIds.size > 0" class="footer-text">
      {{ selectedArticleIds.size }} of {{ currentArticles.length }} selected
    </span>

    <ion-buttons
      *ngIf="selectedArticleIds.size > 0"
      class="bulk-action-buttons"
    >
      <ion-button
        (click)="selectAllArticles()"
        fill="clear"
        color="dark"
        [hidden]="selectedArticleIds.size === currentArticles.length"
      >
        Select all
      </ion-button>
      <ion-button (click)="deselectAllArticles()" fill="clear" color="dark">
        Deselect all
      </ion-button>
      <ion-button
        (click)="bulkMoveArticles($event)"
        fill="clear"
        class="button-dark-border"
      >
        <ion-icon name="folder-open-outline" class="padded-icon"></ion-icon>
        Move
      </ion-button>
      <ion-button
        (click)="bulkAddTag($event)"
        fill="clear"
        class="button-dark-border"
      >
        <ion-icon name="pricetag-outline" class=""></ion-icon>
        <span class="icon-plus-accessory padded-icon">+</span>
        Apply tags
      </ion-button>
      <ion-button
        (click)="bulkRemoveTag($event)"
        fill="clear"
        class="button-dark-border"
      >
        <ion-icon name="pricetag-outline"></ion-icon>
        <span class="icon-plus-accessory padded-icon">-</span>
        Remove tags
      </ion-button>
      <ion-button
        (click)="openBulkManageGroupsModal()"
        fill="clear"
        class="button-dark-border"
      >
        <ion-icon name="people-outline" class="padded-icon"></ion-icon>
        Manage groups
      </ion-button>
      <ion-button
        (click)="openBulkManageChannelsModal()"
        fill="clear"
        class="button-dark-border"
      >
        <ion-icon name="chatbubble-outline" class="padded-icon"></ion-icon>
        Manage channels
      </ion-button>
      <ion-button
        (click)="bulkDeleteArticles()"
        fill="clear"
        class="button-dark-border"
      >
        <ion-icon
          name="trash-outline"
          color="danger"
          class="padded-icon"
        ></ion-icon>
        Delete
      </ion-button>
      <!-- Add other bulk actions here -->
    </ion-buttons>
  </div>
</ion-footer>

<!-- ===================== -->
<!-- Recursive Node Template -->
<!-- ===================== -->
<ng-template #treeNodeTemplate let-nodes="nodes">
  <ng-container *ngFor="let node of nodes; let i = index">
    <ion-row
      *ngIf="
        node.type !== 'create-action' &&
        node.type !== 'create-root-article-action'
      "
      [id]="'node-' + node.id"
      class="tree-node-row"
      [class.selected-node]="selectedNode?.id === node.id"
      [class.is-article]="node.type === 'article'"
      (contextmenu)="showContextMenu($event, node)"
      draggable="true"
      (dragstart)="onDragStart($event, node)"
      (dragend)="onDragEnd($event)"
      (dragover)="onDragOver($event, node)"
      (drop)="onDrop($event, node)"
      [attr.aria-level]="node.level + 1"
      [attr.aria-selected]="selectedNode?.id === node.id"
    >
      <ion-col size="auto" class="col-control col-ellipsis">
        <div class="node-prefix-icons">
          <ion-button
            *ngIf="node.type === 'collection' || node.type === 'article'"
            fill="clear"
            class="actions-button"
            (click)="showContextMenu($event, node); $event.stopPropagation()"
            aria-label="Actions"
          >
            <ion-icon
              slot="icon-only"
              name="ellipsis-horizontal"
              aria-hidden="true"
            ></ion-icon>
          </ion-button>
        </div>
      </ion-col>

      <ion-col
        size=""
        class="col-content"
        (click)="handleNodeClick(node, $event)"
      >
        <div
          class="indented-content"
          [style.padding-left]="node.level * 20 + 'px'"
        >
          <div
            class="checkbox-container"
            [class.is-selected]="selectedArticleIds.has(node.id)"
          >
            <ion-icon
              [name]="
                node.type === 'collection'
                  ? node.expanded
                    ? 'custom-folder-open'
                    : 'folder'
                  : 'document-text-outline'
              "
              class="node-icon-checkbox-combo"
              aria-hidden="true"
            ></ion-icon>
            <ion-checkbox
              *ngIf="node.type === 'article'"
              class="article-select-checkbox"
              [checked]="selectedArticleIds.has(node.id)"
              (ionChange)="toggleArticleSelection(node, $event)"
              (click)="$event.stopPropagation()"
              [attr.aria-label]="'Select article ' + node.name"
            ></ion-checkbox>
          </div>
          <ion-label class="node-label">
            <div class="node-name">{{ node.name }}</div>
            <div
              *ngIf="node.type === 'collection' && node.description"
              class="node-description"
            >
              {{ node.description }}
            </div>
            <ion-text *ngIf="node?.data?.status === 'inactive'" color="warning">
              (Inactive)
            </ion-text>
          </ion-label>
        </div>
      </ion-col>

      <ion-col
        *ngIf="node.type === 'article'"
        size="auto"
        class="col-tags ion-text-right"
      >
        <div class="tags-display-container">
          <ion-badge
            mode="ios"
            color="light"
            class="small-tag-badge"
            *ngFor="let tag of node.tags"
            [title]="tag.name"
          >
            <ion-icon name="pricetag"></ion-icon>
            <ion-label>{{ tag.name }}</ion-label>
          </ion-badge>
          <ion-badge
            mode="ios"
            color="secondary"
            class="small-tag-badge"
            *ngFor="let group of node.data?.userGroups"
            [title]="group.name"
          >
            <ion-icon name="people"></ion-icon>
            <ion-label>{{ group.name }}</ion-label>
          </ion-badge>
          <ion-badge
            mode="ios"
            color="secondary"
            class="small-tag-badge"
            *ngFor="let channel of node.data?.channels"
            [title]="channel.name"
          >
            <ion-icon name="chatbubble"></ion-icon>
            <ion-label>{{ channel.name }}</ion-label>
          </ion-badge>
        </div>
      </ion-col>

      <ion-col size="auto" class="col-updated-at">
        <span *ngIf="node.updatedAt" class="updated-at-column ion-text-nowrap">
          {{ node.updatedAt | date: "shortDate" }}
        </span>
      </ion-col>

      <ion-col size="auto" class="col-spinner">
        <ion-spinner *ngIf="node.isLoadingChildren" name="dots"></ion-spinner>
      </ion-col>
    </ion-row>

    <ion-row
      *ngIf="node.type === 'create-action'"
      class="tree-node-row create-action-item"
      (click)="handleCreateActionClick($event)"
      tappable
    >
      <ion-col size="auto" class="col-control col-ellipsis"></ion-col>
      <ion-col size="" class="col-content">
        <div class="create-action-content">
          <ion-icon name="add-outline" aria-hidden="true"></ion-icon>
          <span>Create new collection</span>
        </div>
      </ion-col>
      <ion-col size="auto" class="col-updated-at"></ion-col>
      <ion-col size="auto" class="col-spinner"></ion-col>
    </ion-row>

    <ion-row
      *ngIf="node.type === 'create-root-article-action'"
      class="tree-node-row create-action-item"
      (click)="newArticle(null, $event)"
      tappable
    >
      <ion-col size="auto" class="col-control col-ellipsis"></ion-col>
      <ion-col size="" class="col-content">
        <div class="create-action-content">
          <ion-icon name="document-text-outline" aria-hidden="true"></ion-icon>
          <span>Create new article</span>
        </div>
      </ion-col>
      <ion-col size="auto" class="col-updated-at"></ion-col>
      <ion-col size="auto" class="col-spinner"></ion-col>
    </ion-row>

    <div
      *ngIf="node.type === 'collection' && node.expanded"
      class="child-nodes-container"
      role="group"
    >
      <ng-container
        *ngTemplateOutlet="
          treeNodeTemplate;
          context: { nodes: node.children || [] }
        "
      ></ng-container>
    </div>
  </ng-container>
</ng-template>

<!-- Hidden file input for document import -->
<input
  #fileInput
  type="file"
  style="display: none"
  (change)="onFileSelected($event)"
  accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt,.md,.html,.htm,.csv,.json,.xml,.eml,.msg,.png,.jpg,.jpeg,.gif,.bmp,.tiff,.svg"
/>

<!-- Modal for AI Tester -->
<ion-modal
  [isOpen]="showRunQueryModal"
  (willDismiss)="onDismissRunQueryModal()"
  class="run-query-modal modal-large"
>
  <ng-template>
    <article style="height: 100%">
      <app-admin-ai-tester></app-admin-ai-tester>
    </article>
  </ng-template>
</ion-modal>

<!-- Modal for Import Document Options -->
<ion-modal
  [isOpen]="showImportModal"
  (willDismiss)="onDismissImportModal()"
  class="modal-sm"
>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Import Document Options</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="onDismissImportModal()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div *ngIf="!isUploading" class="margin-top-10">
        <ion-item class="padded-item-vertial">
          <ion-label position="stacked">File</ion-label>
          <ion-button
            fill="outline"
            (click)="triggerFileInput()"
            [disabled]="!featureEnabled"
          >
            <ion-icon name="cloud-upload-outline" slot="start"></ion-icon>
            {{ selectedFile ? "Change File" : "Select File" }}
          </ion-button>
        </ion-item>

        <ion-item *ngIf="selectedFile">
          <ion-label class="ion-text-wrap">
            <p>
              <strong>{{ selectedFile.name }}</strong>
            </p>
            <p style="font-size: 0.85rem; color: var(--ion-color-medium)">
              {{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB
            </p>
          </ion-label>
        </ion-item>

        <ion-item class="padded-item-vertial">
          <ion-label position="stacked">Title (optional)</ion-label>
          <ion-input
            [(ngModel)]="importOptions.title"
            placeholder="Leave blank to use filename"
          ></ion-input>
        </ion-item>

        <ion-item
          class="padded-item-vertial"
          button
          (click)="showCollectionSelectorForImport($event)"
        >
          <ion-icon
            name="folder-outline"
            slot="start"
            class="margin-right-5"
          ></ion-icon>
          <ion-label> Collection (optional): </ion-label>
          <ion-label slot="end">
            {{ getCollectionNameForImport() }}
          </ion-label>
        </ion-item>

        <ion-item class="padded-item-vertial">
          <ion-icon
            name="image-outline"
            slot="start"
            class="margin-right-5"
          ></ion-icon>
          <ion-label>Extract Images:</ion-label>
          <ion-toggle
            [(ngModel)]="importOptions.extractImages"
            slot="end"
          ></ion-toggle>
        </ion-item>

        <!-- Parsing Strategy - commented out for internal testing only -->
        <!--
        <ion-item>
          <ion-label position="stacked">Parsing Strategy</ion-label>
          <ion-select
            [(ngModel)]="importOptions.strategy"
            placeholder="Select strategy"
            interface="popover"
          >
            <ion-select-option value="auto">Auto</ion-select-option>
            <ion-select-option value="hi_res">High Resolution</ion-select-option>
            <ion-select-option value="fast">Fast</ion-select-option>
            <ion-select-option value="vlm">Vision Language Model (VLM)</ion-select-option>
            <ion-select-option value="ocr_only">OCR Only</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item *ngIf="importOptions.strategy === 'vlm'">
          <ion-label position="stacked">VLM Provider</ion-label>
          <ion-select
            [(ngModel)]="importOptions.vlmModelProvider"
            placeholder="Select provider"
            interface="popover"
          >
            <ion-select-option value="anthropic">Anthropic</ion-select-option>
            <ion-select-option value="openai">OpenAI</ion-select-option>
            <ion-select-option value="bedrock">AWS Bedrock</ion-select-option>
            <ion-select-option value="vertex">Google Vertex AI</ion-select-option>
          </ion-select>
        </ion-item>
        -->

        <div class="padding-20">
          <ion-text color="medium" style="font-size: 0.85rem">
            Supports 65+ file types: PDF, DOCX, PPTX, XLSX, images, HTML,
            Markdown, CSV, emails, and more. Max file size: 100MB.
          </ion-text>
        </div>
      </div>

      <div *ngIf="isUploading" class="upload-progress">
        <ion-spinner name="crescent"></ion-spinner>
        <p>Importing document...</p>
        <p class="ion-text-center">
          <ion-text color="medium">
            This may take a moment for large files
          </ion-text>
        </p>
      </div>
    </ion-content>
    <ion-footer *ngIf="!isUploading" class="padding-10">
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="onDismissImportModal()" fill="clear">
            Cancel
          </ion-button>
          <ion-button
            (click)="confirmImport()"
            [disabled]="!selectedFile"
            class="button-dark-border"
          >
            Import
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
